<template>
	<div class='main-mybody1' id='ediofour'>
		<a-row>
			<a-col :span='6'>開始時間 <a-date-picker 
			v-model='params.begindate' placeholder='請選擇開始時間' :disabled-date="disabledDate" style='width: 12rem;'/></a-col>
			<a-col :span='6'>結束時間 <a-date-picker 
			v-model='params.enddate' placeholder='請選擇結束時間' :disabled-date="disabledDates" style='width: 12rem;'/>
			<!-- <a-range-picker :placeholder="['開始時間','結束時間']" format="DD/MM/YYYY"
				v-model="params.timeDate" @change='fanhand'> -->
			</a-range-picker>
			</a-col>
			<a-col :span='4'>
				<div class='wrplf'>
					<a-button class="topBtn" style="background-color:#3bc7a1;" @click="getdate">
						<img src="@/image/icon_sousuo.png" class="btnIcon" />
						<span>搜索</span>
					</a-button>
					<a-button class="topBtn" style="background-color:#ffa647;margin-left:auto;"
						@click="clearEvent">
						<img src="@/image/icon_chongzhi.png" class="btnIcon" />
						<span>重置</span>
					</a-button>
				</div>
			</a-col>
			<a-col :span='24'>
				<div class='look_g'>
					<div></div>登入/登出
				</div>
				<div id='bottomMain'>
					<a-table
						id='ediotable'
					    style="width:100%;"
					    :columns="columns"
					    :data-source="columnsData"
						:rowKey='(record, index) => index'
						:bordered="true"
						:pagination="false"
					    ></a-table>
						<div class="paginationView">
							<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
							<div style="margin-left:auto;">
								<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
									:pageSize="params.perPage" />
							</div>
							<div class="pageTzView">
								<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
								<span @click="tzEvent">跳轉</span>
							</div>
						</div>
						<!--:pagination="false" -->
				</div>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	export default {
		data(){
			return {
				tzPageNum:'',
				columns:[
					 // { title: 'D', dataIndex: 'key' },
				    {title: '登入時間',dataIndex: 'logintime',align:'center',width:'20%'},
					{title: '登出時間',dataIndex: 'logouttime',align:'center',width:'20%'},
				    {title: '在綫時長',dataIndex: 'hour_minutes',align:'center',width:'20%'},
				    {title: 'IP地址',dataIndex: 'ip_address',align:'center',width:'20%'},
					{title: '訪問地區',dataIndex: 'ip_area',align:'center',width:'20%'},
				],
				columnsData:[],
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					begindate: '',
					enddate: '',
					perPage: 10, //每頁條目數
					}
			}
		},
		computed:{
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
			
		},
		mounted() {
			this.getdate()
		},
		methods:{
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.getdate();
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.begindate = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					//認購截止日期
					this.params.enddate = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			getdate(){
				this.params.begindate = this.params.begindate._d? App.oDate.secsTime3(this.params.begindate._d) : this.params.begindate
				this.params.enddate = this.params.enddate._d ? App.oDate.secsTime3(this.params.enddate._d) : this.params.enddate
				
				this.params.token = this.$store.state.token
				this.$ajax({
					method: 'post',
					url: this.$api.getLoginLogList,
					data: this.params
				}).then(res => {
					if(res.data.qmiscode == 1000){
						this.columnsData = res.data.loginLogList
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
					}else{
						 this.$message.warning(res.data.qmismsg)
					}
				})
			},
			disabledDate(current) {
				if(this.params.enddate){
					return current && current > this.params.enddate;
				}else{
					return false
				}
			},
			disabledDates(current){
				if(this.params.begindate){
					return current && current < this.params.begindate;
				}else{
					return false
				}
			},
			clearEvent(){
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					begindate: '',
					enddate: '',
					perPage: 10, //每頁條目數
				}
				this.getdate()
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
		}
	}
</script>

<style lang="scss">
	#ediofour {
		.ant-table-thead > tr:first-child > th:first-child{
			font-size: .8rem;
		}
		.ant-table-thead > tr > th{
			font-size: .8rem;
		}
		.ant-col {
		    margin: 0.4rem 0 .5rem !important;
		}
		.ant-pagination-prev, .ant-pagination-next, .ant-pagination-jump-prev, .ant-pagination-jump-next{
			    min-width: 28px;
				height: 1.5rem;
				min-height: 28px;
				line-height: 1.5rem;
		}
		.ant-pagination-item{
			    min-width: 28px;
			    height: 1.5rem;
			    min-height: 28px;
			    line-height: 1.5rem;
		}
		.bottomMain {
		    background-color: #fff;
		    display: flex;
		    align-items: center;
		    padding: 1.6rem 1.04rem;
		}
		.wrplf{
			display: flex;
			justify-content: space-between;
		}
		.topBtn {
		    padding: 0px 1.04rem;
		    border-radius: 2.6rem;
		    /* margin-left:0.8rem; */
		    color: #fff;
		    display: inline-flex;
		    align-items: center;
		}
		.ant-table-tbody{
			
		}
	}
	#ediotable tr td:nth-last-child(1),
	#ediotable tr th:nth-last-child(1) {
	    border-right: 1px solid #e8e8e8!important;
	}
	
	#ediotable .ant-table-bordered .ant-table-thead>tr>th,
	#ediotable .ant-table-bordered .ant-table-tbody>tr>td {
	    border-right: unset;
	}
	#ediofour .paginationView {
	    padding: 0.5rem 0;
	    display: flex;
	    align-items: center;
	    width: 100%;
	    color: #666666;
		/* height:calc(100vh - 142px); */
	}
	
	#ediofour .ant-pagination-item {
	    background-color: #fff;
	    border-color: #bfbfbf;
	    color: #999999;
	    margin-right: 1rem;
	}
	
	#ediofour .ant-pagination-prev {
	    margin-right: 1rem;
	}
	
	#ediofour .ant-pagination-item a {
	    color: inherit;
	}
	
	#ediofour .ant-pagination-item-active {
	    background-color: #f3f3f3;
	    border-color: #d8d8d8;
	    color: #000;
	}
	
	#ediofour .ant-pagination-prev .ant-pagination-item-link,
	#ediofour .ant-pagination-next .ant-pagination-item-link {
	    background-color: #fff;
	    color: #666666;
	    border: 1px solid #bfbfbf;
	}
	
	#ediofour .ant-pagination-disabled a,
	#ediofour .ant-pagination-disabled:hover a,
	#ediofour .ant-pagination-disabled:focus a,
	#ediofour .ant-pagination-disabled .ant-pagination-item-link,
	#ediofour .ant-pagination-disabled:hover .ant-pagination-item-link,
	#ediofour .ant-pagination-disabled:focus .ant-pagination-item-link {
	    background-color: #d8d8d8!important;
	    color: #fff!important;
	}
	
	#ediofour .pageTzView {
	    display: flex;
	    align-items: center;
	    margin-left: 0.7rem;
	}
	
	#ediofour .pageTzView input {
	    width: 2.6rem;
	    height: 1.5rem;
	    border: 1px solid #bfbfbf;
	    outline: unset;
	    margin-right: 0.25rem;
	    border-radius: 4px;
	    text-align: center;
	}
	
	#ediofour .pageTzView span {
	    background-color: #d8d8d8;
	    border-radius: 4px;
	    height: 1.5rem;
	    color: #666666;
	    padding: 0 0.625rem;
	    line-height: 1.5rem;
	}
	
</style>
